// Vendors
import { useLayoutEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
// Contexts
import { useAppContextConsumerHook } from 'contexts/app.context';
import { useAppInformationContextConsumerHook } from 'contexts/app-information.context';
// Event handlers
import { CheckoutHandlers } from '../handlers/checkout.handlers';

const useCheckoutHook = (): void => {
  const { showBoundary: setError } = useErrorBoundary(),
    { setCheckoutOrderData, setCallbackUrl, setCustomerName, setLoanId } =
      useAppContextConsumerHook(),
    { setInformationFlags, informationFlags } = useAppInformationContextConsumerHook();

  const { handleFetchCheckoutOrderData } = CheckoutHandlers({
    informationFlags,
    setCallbackUrl,
    setCheckoutOrderData,
    setCustomerName,
    setError,
    setInformationFlags,
    setLoanId,
  });

  useLayoutEffect(() => {
    handleFetchCheckoutOrderData();
  }, [informationFlags]);
};

export { useCheckoutHook };
